import React from "react";

const words = [
  "THRIFTHOUSE",
  "WEAR YOUR STORY",
  "LIMITED DROP",
  "CURATED THRIFT",
  "LUXURY STREETWEAR",
];

export const Marquee = ({ className = "" }) => {
  const content = [...words, ...words];
  return (
    <div className={`overflow-hidden border-y border-white/10 py-5 ${className}`} data-testid="marquee-band">
      <div className="marquee-track">
        {content.map((w, i) => (
          <span
            key={i}
            className="font-display text-3xl md:text-5xl font-black uppercase tracking-tight text-white/10 mx-6 flex items-center gap-6"
          >
            {w}
            <span className="text-white/20 text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
